import { render } from "./order-expired.vue?vue&type=template&id=2894c852&ts=true"
import script from "./order-expired.vue?vue&type=script&lang=ts"
export * from "./order-expired.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__